<template>
  <transition name="el-zoom-in-center">
    <el-card class="box-card" style="text-align: left;" v-show="add.addshow">
      <el-steps :active="active" align-center>
        <el-step title="填写基本信息"></el-step>
        <el-step title="填写具体奖项"></el-step>
      </el-steps>
      <el-divider></el-divider>
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增模板</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <div v-show="show">
        <el-form ref="form" :model="form" label-width="110px" style="width:100%;" :rules="rules">
          <el-row>
            <el-col :span="8" :offset="8">
              <el-form-item label="模板名称" prop="luckydrawRuleName">
                <el-input v-model="form.luckydrawRuleName" style="width:80%"></el-input>
              </el-form-item>
              <el-form-item label="奖励对象" prop="awardObjectType">
                <el-select
                  v-model="form.awardObjectType"
                  @change="getpackageLevel(form.awardObjectType)"
                  placeholder="请选择"
                  style="width:80%"
                >
                  <el-option
                    v-for="item in awardObjectType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="模板类型" prop="luckydrawChanceType">
                <el-select
                  :disabled="form.awardObjectType=='3'"
                  v-model="form.luckydrawChanceType"
                  placeholder="请选择"
                  @change="luckydrawChanceTypechange($event)"
                  style="width:80%"
                >
                  <el-option
                    v-for="item in luckydrawChanceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="awardRemark">
                <el-input type="textarea" v-model="form.awardRemark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="next('form')" type="primary">下一步</el-button>
        </div>
      </div>
      <div v-show="!show">
        <!-- 填写具体奖项 -->
        <h4>模板记录</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form
                ref="ruleform"
                :model="ruleform"
                label-width="100px"
                style="width:80%"
                :rules="rules"
              >
                <el-form-item label="奖项标题" prop="awardLevelName">
                  <el-input v-model="ruleform.awardLevelName" style="width:60%"></el-input>
                </el-form-item>
                <el-form-item label="奖励类型" prop="awardStuffType">
                  <el-select
                    :label-in-value="true"
                    v-model="ruleform.awardStuffType"
                    placeholder="请选择"
                    style="width:60%"
                    @change="awardStuffTypechange($event)"
                  >
                    <el-option
                      v-for="item in awardStuffTypelist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="awardlabel" prop="awardStuffUuid">
                  <el-select
                    v-model="ruleform.awardStuffUuid"
                    @change="awardStuffUuidchange($event)"
                    placeholder="请选择"
                    style="width:60%"
                  >
                    <el-option
                      v-for="item in awardStuffUuidlist"
                      :key="item.awardStuffUuid"
                      :label="item.awardStuffName"
                      :value="item.awardStuffUuid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="比例"
                  prop="luckydrawRate"
                  v-show="this.form.luckydrawChanceType == 0"
                >
                  <el-input v-model.number="ruleform.luckydrawRate" style="width:60%">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="可中奖数"
                  prop="luckydrawCount"
                  v-show="this.form.luckydrawChanceType == 1"
                >
                  <el-input v-model.number="ruleform.luckydrawCount" style="width:60%"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('ruleform')">重置</el-button>
                <el-button
                  style="margin-top: 12px;"
                  type="primary"
                  @click="productadd('ruleform')"
                >生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right"></el-button>
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table :data="form.luckydrawRuleDetails" stripe style="width: 100%">
                <el-table-column prop="awardLevelName" label="奖励标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="awardStuffTypename" label="奖励类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="luckydrawChanceTypename" label="模板类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="awardStuffName" label="奖励明细" show-overflow-tooltip></el-table-column>
                <el-table-column prop="luckydrawRate" label="比例" min-width="100"></el-table-column>
                <el-table-column prop="address" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        type="danger"
                        @click.native.prevent="deleteRow(scope.$index, form.luckydrawRuleDetails)"
                      >删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="next('form')" type="primary">上一步</el-button>
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>
<script>
import {
  luckydrawruleadd,
  findlistbytypeandgroup
} from "@/api/market/marketing";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      show: true,
      active: 1,
      awardObjectType: [
        {
          value: "1",
          label: "消费者/一般厨师"
        },
        {
          value: "3",
          label: "分销商"
        }
      ],
      luckydrawChanceType: [
        {
          value: 0,
          label: "按比例"
        },
        {
          value: 1,
          label: "按箱"
        }
      ],
      awardStuffTypelist: [
        {
          value: 0,
          label: "红包"
        },
        {
          value: 1,
          label: "积分"
        },
        {
          value: 2,
          label: "实物"
        },
        {
          value: 3,
          label: "优惠卷"
        }
      ],
      awardStuffUuidlist: [],
      form: {
        awardRemark: null,
        awardObjectType: null,
        luckydrawChanceType: null,
        luckydrawChanceTypename: null,
        luckydrawRuleName: null,
        luckydrawUsedSum: 0,
        packageLevel: null,
        luckydrawRuleState: 0.0,
        luckydrawRuleDetails: []
      },
      awardlabel: "金额",
      ruleform: {
        //步骤1 表单
        awardLevelName: null,
        awardStuffType: null,
        awardStuffUuid: null,
        luckydrawRate: 0,
        awardStuffTypename: null,
        awardStuffName: null,
        luckydrawCount: 0
      },
      // 步骤2表格数据
      rules: {
        Remark: [
          { required: true, message: "请输入备注", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        awardObjectType: [
          { required: true, message: "请输入奖励对象", trigger: "blur" }
        ],
        luckydrawChanceType: [
          { required: true, message: "请输入奖励类型", trigger: "blur" }
        ],
        luckydrawRuleName: [
          { required: true, message: "请输入模板名称", trigger: "blur" }
        ],
        luckydrawRate: [
          { type: "number", message: "必须为整数值" },
          ,
          { validator: this.validateAcquaintance, trigger: "blur" }
        ],
        awardLevelName: [
          { required: true, message: "请输入奖项标题", trigger: "blur" }
        ],
        awardStuffType: [
          { required: true, message: "请选择奖励类型", trigger: "blur" }
        ],
        awardStuffUuid: [
          { required: true, message: "请选择奖品明细", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
        // 验证
    validateAcquaintance(rule, value, callback) {
      if (value < 0 || value > 100) {
        callback(new Error("中奖比例必须在 0 至 100 %之间"));
      } else {
        callback();
      }
    },
    // 获取包装级别
    getpackageLevel(value) {
      this.form.luckydrawChanceType = 0;
      switch (value) {
        case "1":
          this.form.packageLevel = 1; // 奖励对象为消费者，保证级别为1
          break;
        case "3":
          this.form.packageLevel = 2; // 分销商 ，为2
          break;
        default:
          break;
      }
    },
    // 奖品类型选中后
    awardStuffTypechange(e) {
      findlistbytypeandgroup({
        page: 1,
        rows: 1000,
        awardType: this.ruleform.awardStuffType,
      }).then(response => {
        // 获取奖励明细下拉
        this.awardStuffUuidlist = response.data.rows;
        console.log(response.data);
      });
      let obj = {};
      obj = this.awardStuffTypelist.find(item => {
        //这里的userList就是上面遍历的数据源
        return item.value === e; //筛选出匹配数据
      });
      console.log(obj.label);
      this.ruleform.awardStuffTypename = obj.label;
      this.ruleform.awardStuffUuid = null;
      switch (
        this.ruleform.awardStuffType // 下拉label显示
      ) {
        case 0:
          this.awardlabel = "金额";
          break;
        case 1:
          this.awardlabel = "积分";
          break;
        case 2:
          this.awardlabel = "实物";
          break;
        case 3:
          this.awardlabel = "优惠卷";
          break;
        default:
          break;
      }
    },
    // 奖品明细选中后
    awardStuffUuidchange(e) {
      let obj = {};
      obj = this.awardStuffUuidlist.find(item => {
        return item.awardStuffUuid === e; //筛选出匹配数据
      });
      this.ruleform.awardStuffName = obj.awardStuffName;
    },
    // 模板类型选中后
    luckydrawChanceTypechange(e) {
      let obj = {};
      obj = this.luckydrawChanceType.find(item => {
        return item.value === e; //筛选出匹配数据
      });
      this.form.luckydrawChanceTypename = obj.label;
    },
    // 步骤条
    next(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.show = !this.show;
          if (this.active++ >= 2) {
            this.active = 1;
          }
        } else {
          return false;
        }
      });
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const obj = {};
          obj["awardLevelName"] = this.ruleform.awardLevelName;
          obj["awardStuffType"] = this.ruleform.awardStuffType;
          obj["awardStuffTypename"] = this.ruleform.awardStuffTypename;
          obj["awardStuffUuid"] = this.ruleform.awardStuffUuid;
          obj["awardStuffName"] = this.ruleform.awardStuffName;
          obj["luckydrawRate"] = this.ruleform.luckydrawRate / 100;
          obj["luckydrawCount"] = this.ruleform.luckydrawCount;
          obj["luckydrawChanceType"] = this.form.luckydrawChanceType;
          obj["luckydrawChanceTypename"] = this.form.luckydrawChanceTypename;
          obj["awardNumber"] = 0;
          this.form.luckydrawRuleDetails.push(obj);
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          luckydrawruleadd(this.form).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!"
              });
              this.search();
              this.form.luckydrawRuleDetails = [];
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
